/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import {CUSTOM_ELEMENTS_SCHEMA, Component, effect, forwardRef, input, signal} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule} from '@angular/forms';
import {Date_Regex} from '@app/shared/constants';
import {PrimeNgModule} from '@app/shared/modules/prime-ng/prime-ng.module';

@Component({
  selector: 'app-masked-calendar',
  imports: [FormsModule, ReactiveFormsModule, PrimeNgModule],
  templateUrl: './masked-calendar.component.html',
  styleUrl: './masked-calendar.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MaskedCalendarComponent),
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MaskedCalendarComponent implements ControlValueAccessor {
  disabled = input(false);
  readonly _disabled = signal(false);
  readonly required = input(false);
  readonly maxDate = input<Date | null>(null);
  readonly minDate = input<Date | null>(null);
  readonly disabledDates = input<Date[]>([]);

  constructor() {
    effect(() => {
      this._disabled.set(this.disabled());
    });
  }

  calendarValue: Date | null = null;
  inputMaskValue: string = '';

  onChange = (_: any) => {};

  onTouched = () => {};

  registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this._disabled.set(isDisabled);
  }

  writeValue(value: any): void {
    this.calendarValue = value;
    this.inputMaskValue = this.formatCalendarValue(value);
  }

  private formatCalendarValue(calendarValue: Date | null): string {
    if (calendarValue) {
      const day = String(calendarValue.getDate()).padStart(2, '0');
      const month = String(calendarValue.getMonth() + 1).padStart(2, '0');
      const year = calendarValue.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return '';
  }

  private parseInputMaskValue(inputMaskValue: string): Date | null {
    if (inputMaskValue) {
      const dateParts = inputMaskValue.split('/');
      const day = +dateParts[0];
      const month = +dateParts[1] - 1;
      const year = +dateParts[2];
      return new Date(year, month, day);
    }
    return null;
  }

  onInputMaskChange(event: any): void {
    if (Date_Regex.test(event)) {
      const evt = {target: {value: event}};
      this.onInputMaskBlur(evt);
    }
  }

  onInputMaskBlur(event: any): void {
    this.inputMaskValue = event.target.value;
    const calendarValue = this.parseInputMaskValue(this.inputMaskValue);
    this.writeValue(calendarValue);
    this.onChange(calendarValue);
  }

  onCalendarSelect(event: any): void {
    this.calendarValue = event;
    this.writeValue(this.calendarValue);
  }
}
